import {

    GET_REPORTING_CHART,
    REPORTING_ACTION_ERROR

} from "../../actions/admin/ReportingActions";

const initialState = {
    reportingChartData: [],
    failed: false,
    showAlert: false,
    alertMessage: "",
    alertVariant: "",
};

const ReportingReducer = function (state = initialState, action) {
    switch (action.type) {

        case GET_REPORTING_CHART: {
            return {
                ...state,
                reportingChartData: [...action.data]
            };
        }
        case REPORTING_ACTION_ERROR: {
            return {
                ...state,
                failed: true,
                showAlert: true,
                alertMessage: action.data,
            };
        }
        default: {
            return state;
        }
    }
};

export default ReportingReducer;